import React from 'react'
import { useParams } from 'react-router-dom'

const withParams = WrappedComponent => {
  return props => {
    const params = useParams()
    const { camperId } = params

    return <WrappedComponent camperId={camperId} {...props} />
  }
}

export default withParams
